import { memo } from 'react';
import Image from 'next/image';
import styles from '@components/ProductCardNew/ProductImage/PackshotImage/PackshotImage.styles';
import { arrangementSizes } from '@components/ProductCardNew/const';
import getImageQuality from '@utils/getImageQuality';
import MissingPicturePlaceholder from '@components/ProductCardNew/ProductImage/MissingPicturePlaceholder/MissingPicturePlaceholder';
type PropsType = {
  url: string;
  alt: string;
  onLoadFunc?: () => void;
  onErrorFunc?: () => void;
  standardLoaded?: boolean;
  showPlaceholder?: boolean;
  isBig?: boolean;
  isSmall?: boolean;
  isSlider?: boolean;
};
const PackshotImage = memo(({
  url,
  alt,
  onLoadFunc,
  onErrorFunc,
  standardLoaded = true,
  showPlaceholder = false,
  isBig = false,
  isSmall = false,
  isSlider = false
}: PropsType) => {
  if ((!url || url === '') && onErrorFunc) onErrorFunc();
  return <div sx={styles.packshostSpace(isBig, isSmall, isSlider)}>
        <div sx={styles.imageContainer(!standardLoaded)}>
          {!standardLoaded && showPlaceholder && <MissingPicturePlaceholder />}
          <Image alt={alt} src={url} fill quality={getImageQuality()} sizes={arrangementSizes} onLoad={onLoadFunc} onError={onErrorFunc} />
        </div>
      </div>;
});
PackshotImage.displayName = 'PackshotImage';
export default PackshotImage;